<template>
  <v-container fluid>
    <section class="collection">
      <div class="swiper mySwiper">
        <div class="swiper-wrapper">
          <div class="content swiper-slide" v-for="(slide, index) in slides" :key="index">
            <img
              :src="require(`@/assets/clients/${slide.image}`)"
              alt="Image"
              class="centered-image"
              style="width: 100px; height: 100px"
            />

            <div class="text-content">
              <h3>{{ slide.title }}</h3>
              <p class="fdsizex">{{ slide.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </v-container>
</template>
<script>
export default {
  components: {},
  data: () => ({
    slides: [
      {
        image: "client 5.jpg",
        title: "Alexander",
        description:
          '" This platform brings students, parents, and teachers together, enhancing the entire learning experience."',
      },

      {
        image: "client 2.jpg",
        title: "Aiden Gorge",
        description:
          '"Managing attendance and grading has never been easier. The automation features save us hours every week! "',
      },

      {
        image: "client 4.jpg",
        title: "Leo",
        description:
          '"This platform has made everything from scheduling to reporting incredibly smooth and hassle-free. "',
      },
      {
        image: "client 3.jpg",
        title: "Laura M ",
        description:
          '"The school management system has significantly reduced our workload and improved efficiency. "',
      },
      {
        image: "client 6.jpg",
        title: "Thomas Jose",
        description:
          '"Managing student data has never been easier. Our staff loves the intuitive interface. "',
      },
      {
        image: "client 7.jpg",
        title: "David S",
        description:
          '"The system has transformed how we handle student records and communication. Its intuitive and has significantly reduced our admin workload! "',
      },
      {
        image: "client 5.jpg",
        title: "Alexander",
        description:
          '" This platform brings students, parents, and teachers together, enhancing the entire learning experience."',
      },

      {
        image: "client1.jpg",
        title: "Henry Paul",
        description:
          '"An excellent platform that bridges communication between teachers, students, and parents. A must-have for any modern school!"',
      },
      {
        image: "client 7.jpg",
        title: "David S",
        description:
          '"The school management system has significantly reduced our workload and improved efficiency. "',
      },
    ],
  }),

  mounted() {
    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      // Initialize Swiper or any other code that depends on Swiper
      var swiper = new Swiper(".mySwiper", {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        loop: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 150,
          modifier: 2.5,
          slideShadows: true,
        },
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
      });

      new Swiper(".swiper-container", {
        // Your Swiper options
      });
    };
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css");

.collection {
  display: flex;
  justify-content: center;
  align-items: center;
}
.collection .content {
  width: 15rem;

  /* background: linear-gradient(
      90deg,
      rgba(26, 35, 126, 1) 0%,
      rgba(53, 68, 220, 1) 100%
    ); */

  background: linear-gradient(to right, #ee0979, #ff6a00);

  /* background-color: #8ebaf9; */

  border: 0.2rem solid rgba(255, 255, 255, 0.1);
  border-radius: 0.7rem;

  overflow: hidden;
}

.content img {
  width: 100%;

  border-radius: 5px;
}
.text-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.text-content h3 {
  font-size: 1.7rem;
  font-weight: 500;
}
.text-content p {
  max-width: 22rem;
  font-size: 0.8rem;
  font-weight: 400;
  text-align: center;
}
.btn {
  background-color: #0099ff;
  padding: 0.2rem;
  border: 2px solid #0099ff;
  outline: none;
  font-size: 0.8rem;
  border-radius: 0.5rem;
  margin: 1rem 0;
  cursor: pointer;
}
@media screen and (min-width: 1600px) {
  .collection .content {
    height: 25rem !important;
    width: 21rem !important;
  }
  .fdsizex {
    font-size: 18px !important;
    margin-top: 18px;
  }
}

.content {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  height: 100%; /* Ensure the swiper-slide takes the full height */
  text-align: center;
}

.centered-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin-bottom: 10px;
  margin-top: 10px;
}

.text-content {
  padding: 10px;
}
</style>
